import styled, { css } from 'styled-components';

export type TagColors = 'primary' | 'error' | 'mono' | 'green';

export const Tag = styled.div<{ color: TagColors; icon?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  font-weight: 500;
  font-size: 1.4rem;
  padding: ${props => (props.icon ? '0 0.8rem 0 1.4rem' : '0 1rem')};
  color: var(--tag-font-color-${props => props.color});
  background-color: var(--tag-bg-${props => props.color});
  border-radius: 100px;
  height: 2.2rem;
  box-sizing: border-box;
  cursor: pointer;
  user-select: none;

  ${({ icon }) =>
    icon &&
    css`
      content: '';
      width: 1rem;
      height: 1rem;
      background-image: url('/images/common/close.svg');
      background-size: cover;
    `}
`;
